import { render, staticRenderFns } from "./CommentsPage.vue?vue&type=template&id=c17ea59e&scoped=true&"
import script from "./CommentsPage.vue?vue&type=script&lang=js&"
export * from "./CommentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17ea59e",
  null
  
)

export default component.exports